import {MbscModule} from '@mobiscroll/angular';
import {HttpClientModule, withInterceptors, provideHttpClient} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {RouteReuseStrategy} from '@angular/router';
import {ServiceWorkerModule} from '@angular/service-worker';
import {IonicModule, IonicRouteStrategy} from '@ionic/angular';
import {IonicStorageModule} from '@ionic/storage-angular';
import {AppComponent} from './app.component';
import {SignInOutComponent} from "./components";
import {AppRoutingModule} from './app-routing.module';
import {environment} from '../environments/environment';
import {AppTimerService, InactivityService} from './services';
import {httpInterceptor} from './services/http.interceptor';

@NgModule({
  declarations: [AppComponent],
  imports: [
    MbscModule,
    FormsModule,
    BrowserModule,
    SignInOutComponent,
    IonicModule.forRoot({
      innerHTMLTemplatesEnabled: true,
    }),
    AppRoutingModule,
    HttpClientModule,
    IonicStorageModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.production}),
    /*
    TODO: This is the start of switching to more of a reactive model instead of imperative
    StoreModule.forRoot({
      app: coreReducer,
    }),
    StoreDevtoolsModule.instrument({maxAge: 25, logOnly: environment.production}),
    EffectsModule.forRoot([CoreEffects]),
*/
  ],
  providers: [
    AppTimerService,
    InactivityService,
    {provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
    Geolocation,
    provideHttpClient(withInterceptors([
      httpInterceptor,
    ])),
  ],
  bootstrap: [AppComponent],
})

export class AppModule {
}
